module.exports = __webpack_public_path__ + "assets/img/service-module1-3.309df2cd.png";